import React from "react";
import { Box, Typography } from "@mui/material";
import Logo from "../../utilities/images/logo.png";
import {
  flexBetweenWithItemsCenter,
  itemsCenter,
} from "../../utilities/commonStyles/commonStyles";
import { SettingsIcon, LogoutIcon } from "../../utilities/icons/icons";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth, stage } from "../../utilities/firebase/config";

const Navbar = ({ pageTags }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        py: "20px",
      }}
    >
      <Typography
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
        }}
      >
        {stage !== "prod" ? stage : ""}
      </Typography>
      <Box sx={{ px: 5 }}>
        <Box sx={{ ...flexBetweenWithItemsCenter, gap: "20px" }}>
          <Box sx={{ ...itemsCenter, gap: "100px" }}>
            <img
              onClick={() => navigate("/home")}
              src={Logo}
              alt="logo"
              style={{ cursor: "pointer" }}
            />
            <Box sx={{ ...itemsCenter, gap: "10px" }}>
              {pageTags?.map((tag, index) => (
                <>
                  {index > 0 && ">"}
                  <Box
                    key={index}
                    onClick={() => {
                      if (index == 0) {
                        navigate("/home");
                        return;
                      }
                      const number = pageTags.length - (index + 1);
                      // console.log(number);
                      navigate(-number, { replace: true });
                    }}
                    sx={{
                      position: "relative",
                      background: "#F4F7FB",
                      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
                      cursor: "pointer",
                      height: "30px",
                      width: "fit-content",
                      borderRadius: "0 100px 100px 00px",
                      padding: "0 20px",
                    }}
                  >
                    {tag}
                    {/* <Box
                    className={classes.arrowShape}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: "90%",
                      background: "#F4F7FB",
                      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
                      width: "50px",
                      height: "30px",
                    }}
                  ></Box> */}
                  </Box>
                </>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              ...itemsCenter,
              gap: "15px",
            }}
          >
            <Box
              onClick={() => navigate("/settings")}
              sx={{ cursor: "pointer" }}
            >
              <SettingsIcon />
            </Box>
            <Box
              onClick={async () => {
                const confirm = window.confirm("Logout?");
                if (!confirm) {
                  return;
                }
                await signOut(auth);
                window.location.reload();
              }}
              sx={{ cursor: "pointer" }}
            >
              <LogoutIcon />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Navbar;
